<template>
  <div class="list">
     <van-popup :close-on-click-overlay="false" overlay :overlay-style="{ backgroundColor: 'rgba(0, 0, 0, 0.3)' }" v-model="showCertification" round position="center" :style="{ width: '95%' }" >
        <div class="certification-box">
            <p class="certification-title">人脸识别认证</p>
            <div class="certification-text">
                <p>
                     根据《国家税务总局关于互联网平台企业为平台内从业人员办理扣缴申报、代办申报若干事项的公告》政策要求，为确认为您本人操作，我们需要进行人脸识别。
                </p>
                <ul>
                    <li>我们仅收集必要的特征信息用于本次验证。</li>
                    <li>信息将进行加密处理，并严格遵循隐私政策。</li>
                </ul>
            </div>
            <div class="certification-btn-box-btn"> 
                <van-button
                type="primary"
                class="certification-btn"
                 @click="certification"
                >同意并验证</van-button
                >
            </div>
              
        </div>
    </van-popup>
    <job-header-simple
      header_title="我的协议"
      :backRouter="backRouter"
    ></job-header-simple>
    <van-dropdown-menu active-color="#6C7EFC">
      <van-dropdown-item
        v-model="effective"
        @change="changeType"
        :options="option1"
      />
    </van-dropdown-menu>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="init"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
    >
      <div
        class="public_empty_section contract"
        v-if="contractListFilter.length == 0"
      >
        您暂时还没有协议
      </div>
      <div class="item" v-for="item in contractListFilter" :key="item.id">
        <div class="head">{{ item.ocompanyName }}</div>
        <div class="subhead">
          <van-tag round type="primary">服务</van-tag>
          {{ item.ecompanyName }}
        </div>
        <div
          class="text"
          v-if="
            item.status != 'unifiedSignSuccess' &&
              item.status != 'unifiedSignFailure'
          "
        >
          协议日期：{{ item.contractBeginDate }}
          <span v-if="item.contractBeginDate != null">~</span>
          {{ item.contractEndDate }}
        </div>
        <div class="text">
          <span v-if="item.bankName != null && item.bankName == '支付宝'">
            支付宝：({{ item.bankAccount }})
          </span>

          <span v-if="item.bankName != null && item.bankName != '支付宝'">
            银行卡：
            <span class="text-ellipsis">{{ item.bankName }}</span>
            ({{ item.bankAccount }})
          </span>
          <p class="bank-tip" v-if="item.accountIsEnabled">
            <van-icon
              color="#ff5932"
              name="warning-o"
            />收款账号已禁用，请点击“更换”更改有效收款账号
          </p>
        </div>
        <div
          class="status"
          v-if="
            item.status == 'signed' ||
              item.status == 'unifiedSignSuccess' ||
              item.status == 'unifiedSignFailure' ||
              item.accountIsEnabled
          "
        >
          <div class="position">
            <span
              class="icon_type type_did"
              v-if="
                item.status == 'signed' || item.status == 'unifiedSignSuccess'
              "
            ></span>
            <span class="icon_type type_no" v-else> </span>
            <van-button
              type="primary"
              size="mini"
              class="btn_min_theme"
              is-link
              :to="{
                path:
                  '/card?type=1&contractId=' +
                  item.id +
                  '&ocompanyId=' +
                  item.ocompanyId,
              }"
              >更换</van-button
            >
          </div>
          <van-button
            type="warning"
            size="large"
            class="btn_max warning"
            v-if="item.status == 'signed'"
            @click="check(item)"
            >查看协议</van-button
          >
        </div>
        <div class="status" v-if="item.status == 'termination'">
          <div class="position">
            <span class="icon_type type_end"></span>
          </div>
          <van-button
            type="warning"
            size="large"
            class="btn_max warning"
            @click="check(item)"
            >查看协议</van-button
          >
        </div>
        <div class="status" v-if="item.status == 'unifiedSignSuccess'">
          <!-- <div class="position">
            <span class="icon_type type_end"></span>
          </div>
          <van-button
            type="warning"
            size="large"
            class="btn_max warning"
            @click="check(item)"
            >查看协议</van-button
          > -->
        </div>
        <div class="status" v-if="item.status == 'wsign'|| item.status == 'signing' ">
          <template v-if="item.status == 'signing'">
            <div class="position">
              <span class="icon_type type_doing"></span>
            </div>
          </template>
          <template v-else>
            <div class="position">
              <span class="icon_type type_no"></span>
            </div>
          </template>
          <van-button
            type="primary"
            size="large"
            class="btn_max theme"
            @click="signContract(item)"
            >发起电签</van-button
          >
        </div>
        <div class="status" v-if="item.status == 'cancelled'">
          <div class="position">
            <span class="icon_type type_lose"></span>
            <!-- <span class="icon_type type_all"></span> -->
          </div>
          <!--<van-button type="primary" size="large" class="btn_max disabled">查看协议</van-button>-->
        </div>
        <div class="status" v-if="item.status == 'unifiedSignSuccess'">
          <div class="position">
            <span class="icon_type type_all"></span>
            <van-button
              type="primary"
              size="mini"
              class="btn_min_theme"
              is-link
              :to="{
                path:
                  '/card?type=1&contractId=' +
                  item.id +
                  '&ocompanyId=' +
                  item.ocompanyId,
              }"
              >更换</van-button
            >
          </div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import {
  button,
  Tag,
  List,
  Dialog,
  DropdownMenu,
  DropdownItem,
  Icon,
  Toast,
  Popup
} from 'vant'
import jobHeaderSimple from '@/components/header/header.vue'
import { browserUA } from '@/utils/browserUA'
import api from '@/api/list'
import { getIndividualHeaderKey } from '@/utils/auth'

export default {
  components: {
    [button.name]: button,
    [Tag.name]: Tag,
    [List.name]: List,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    jobHeaderSimple,
  },
  data() {
    return {
      contractList: [],
      backRouter: '0',
      showCertification:false,
      effective: 1,
      option1: [
        { text: '全部', value: '' },
        { text: '有效', value: 1 },
        { text: '无效', value: 0 },
      ],
      type: 0,
      page: {
        current: 0,
        size: 10,
        total: 0,
      },
      error: false,
      loading: false,
      finished: false,
    }
  },
  created() {
    //   this.init();
    this.hasFaceVedio();
    if (getIndividualHeaderKey()) {
      this.type = 1
    }
  },
  computed: {
    contractListFilter: function() {
      return this.contractList.filter(
        (item) => item.status != 'unifiedSignFailure' && item.status != 'none'
      )
    },
  },
  // 回退页面问题
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.backRouter = '/user'
    })
  },
  methods: {
    hasFaceVedio(){
        api.hasFaceVedio().then(res=>{
          if(res.status=="200" && res.data.toString()==='0'){
            this.showCertification = true
          }else{
            this.showCertification = false
          }
        })  
    },
        //去认证
    certification(){
         this.showCertification = false
        api.individualFace({},{ method: "post" }).then((res) => {
              if (res.status == '200') {
                let json = JSON.parse(res.data.data)
                if (json == null) {
                  Toast.fail(res.data.message)
                } else {
                  browserUA().then((browserType) => {
                    if (browserType == 'androidAPP') {
                      window.VpShopJs.bodyCheck(
                        JSON.stringify({ url: json.url })
                      )
                    } else {
                      location.href = json.url
                    }
                  })
                }
              } else {
                Toast.fail('发起认证失败')
              }
            })
    },
    changeType() {
      this.page.current = 0
      this.contractList = []
      this.init()
    },
    check(item) {
      if (item.hasContractFileLink !== undefined && !item.hasContractFileLink) {
        Dialog.alert({
          title: '温馨提示',
          message:
            ' 服务商暂不支持第三方平台查看协议，如需查看协议内容请联系客服！',
          confirmButtonText: '知道了',
        })
        return
      }
      if (!item.contractFile) {
        api.contractUrl({ id: item.id }).then((res) => {
          if (res.status == '200') {
            //判断是否安卓设备
            // if (
            //   navigator.userAgent.indexOf("Android") > -1 ||
            //   navigator.userAgent.indexOf("Adr") > -1
            // ) {

            // } else {
            //   window.open(process.env.VUE_APP_FILE_PATH + res.data.data);
            // }

            this.$router.push({
              path: '/checkContract',
              query: {
                fileURL: process.env.VUE_APP_FILE_PATH + res.data.data,
              },
            })
          }
        })
      } else {
        // if (
        //   navigator.userAgent.indexOf("Android") > -1 ||
        //   navigator.userAgent.indexOf("Adr") > -1
        // ) {

        // } else {
        //   window.open(process.env.VUE_APP_FILE_PATH + item.contractFile);
        // }
        this.$router.push({
          path: '/checkContract',
          query: {
            fileURL: process.env.VUE_APP_FILE_PATH + item.contractFile,
          },
        })
        // window.open("http://admin.grejob.com/upload" + item.contractFile);
        // window.open("http://183.62.139.165:85/upload" + item.contractFile);
      }
    },
    init() {
      let param = {}
      param.current = this.page.current + 1
      param.size = this.page.size
      param.type = this.type
      param.effective = this.effective
      api.contractListByActiveUser(param).then((res) => {
        if (res.data.status == '200') {
          this.page.current = res.data.data.current
          this.page.size = res.data.data.size
          let records = res.data.data.records
          this.contractList = this.contractList.concat(records)

          // 加载状态结束
          this.loading = false
          if (res.data.data.current >= res.data.data.pages) {
            this.finished = true
          }
        } else {
          this.loading = false
          this.error = true
        }
      })
    },
    signContract(obj) {
      this.$router.push({
        path: '/contractBase',
        query: { obj: obj.id },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.certification-box{
    font-size: 14px;
    color: #333;
    padding: 0 6px;
    .certification-title{
        font-weight: bold;
        text-align: center;
        height: 40px;
        line-height: 40px;
    }
    .certification-text{
        line-height: 22px;
        p{
            text-indent: 2em;
        }
        ul{
            li{
                position: relative;
                padding-left: 36px;
                margin: 2px 0;
                list-style: none !important;
                &::before {
                content: '•';
                position: absolute;
                left: 25px;
                top: 2px;
                color: #333;
                font-size: 16px;
                line-height: 22px;
                }
            }
        }
        
    }
    .certification-btn-box-btn{
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 30px;
    }
    .certification-cancel{
         width: 100px;
        border-color:  #666;
        color: #333;
        margin-right: 12px;
    }
    .certification-btn{
      width: 120px;
      background: #6c7ef3;
      border-color:  #6c7ef3;
      border-radius: 4px;  
    }
}
.van-dropdown-menu {
  position: fixed;
  right: 6px;
  top: 0;
  width: 80px;
  z-index: 999;
  height: 46px;
  /deep/.van-dropdown-menu__bar {
    box-shadow: none;
    height: 100%;
  }
}
.list {
  .bank-tip {
    color: #ff5932;
    display: flex;
    align-items: center;
    /deep/.van-icon {
      margin-right: 4px;
    }
  }
  .item {
    position: relative;
    margin: 12px;
    border-radius: 6px;
    background: #fff;
    padding: 10px 15px 15px;
    font-size: 13px;
    line-height: 26px;
    .head {
      color: #333;
    }
    .subhead {
      color: #666;
    }
    .text {
      color: #666;
      span {
        color: #333;

        .text-ellipsis {
          display: inline-block;
          vertical-align: middle;
          margin-top: -2px;
          max-width: 10em;
        }
      }
    }
    .status {
      margin-top: 20px;
      .position {
        position: absolute;
        right: 15px;
        top: 10px;
        width: 52px;
        text-align: center;
        .van-button {
          top: -5px;
        }
      }
      .icon_type {
        display: inline-block;
        width: 51px;
        height: 51px;
        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
        &.type_did {
          background-image: url(./assets/type_ok.png);
        }
        &.type_no {
          background-image: url(./assets/type_no.png);
        }
        &.type_doing {
          background-image: url(./assets/type_doing.png);
        }
        &.type_lose {
          background-image: url(./assets/type_ineff.png);
        }
        &.type_end {
          background-image: url(./assets/type_end.png);
        }
        &.type_all {
          background-image: url(./assets/type_all.png);
        }
      }
    }
  }

  .btn_min_warning {
    border-color: #f3a26c;
    background-color: #f3a26c;
  }

  .btn_min_theme {
    margin-left: 0;
    border-color: #6c7ef3;
    background-color: #6c7ef3;
  }

  .btn_max {
    height: 40px;
    line-height: 38px;
    font-size: 14px;

    &.warning {
      border-color: #f3a26c;
      background-color: #f3a26c;
    }

    &.theme {
      border-color: #6c7ef3;
      background-color: #6c7ef3;
    }

    &.disabled {
      border-color: #dadada;
      background-color: #dadada;
    }
  }
}
</style>
